<template>
  <div class="title-add">
    <h3 class="title-add__title">{{title}}</h3>
    <b-dropdown v-if="modal === 'add-event'" no-caret right menu-class="menu-custom">
      <template #button-content>
        <add-button-small />
      </template>
      <b-dropdown-item-button @click="openModal">
        <span>{{ $t('CP.event') }}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button @click="showTransactionModal('even purchase')">
        <span>{{ $t('proposedTransactions.evenPurchase') }}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button @click="showTransactionModal('split purchase')">
        <span>{{ $t('proposedTransactions.splitPurchase') }}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button @click="showTransactionModal('deposit')">
        <span>{{ $t('proposedTransactions.deposit') }}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button v-if="user.gender" @click="showTransactionModal('i purchased them')">
        <span>{{ $t(`proposedTransactions.iBoughtThem_${user.gender || '_M'}`) }}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button @click="showTransactionModal('they purchased me')">
        <span>{{ $t('proposedTransactions.theyBoughtMe') }}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button v-if="user.gender" @click="showTransactionModal('i lent them')">
        <span>{{ $t(`proposedTransactions.iLentThem_${user.gender || '_M'}`) }}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button @click="showTransactionModal('they lent me')">
        <span>{{ $t('proposedTransactions.theyLentMe') }}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button @click="showTransactionModal('comment')">
        <span>{{ $t('proposedTransactions.comment') }}</span>
      </b-dropdown-item-button>
    </b-dropdown>
    <add-button-small v-else @click="openModal" />
  </div>
</template>

<script>
import {
  SET_FINAL_USER_SELECTED_CONTACTS,
  SET_USER_SELECTED_CONTACTS,
  SET_FINAL_EVENT_SELECTED_CONTACTS,
  SET_EVENT_SELECTED_CONTACTS,
} from '@/store/user/types';
import {
  SET_CLONE_OPERATION_INFO,
  SET_OPERATION,
  SET_SPLIT_PURCHASE_INFO,
  SET_OPERATION_IN_ONE_CLICK,
} from '@/store/operations/types';
import AddButtonSmall from '../AddButtonSmall/AddButtonSmall';

export default {
  name: 'TitleAdd',
  components: {
    AddButtonSmall,
  },
  props: {
    title: {
      type: String,
      default() {
        return this.$t('CP.events');
      },
    },
    modal: {
      type: String,
      default() {
        return this.$t('CP.events');
      },
    },
  },
  data() {
    return {
      modalToOpen: '',
      transaction: '',
    };
  },
  methods: {
    openModal() {
      if (this.modalToOpen === 'add-event') {
        const user = { ...this.$store.state.user.user };
        user.full_name = this.$t('CP.me');
        user.uid = user.user;
        this.$store.commit(SET_USER_SELECTED_CONTACTS, [user]);
        this.$store.commit(SET_FINAL_USER_SELECTED_CONTACTS, [user]);
      }
      this.$emit('modalOpened');
      this.$bvModal.show(this.modalToOpen);
    },
    setTransactionParticipants() {
      const currentUser = JSON.parse(JSON.stringify(this.user));
      currentUser.full_name = this.$t('CP.me');

      const contacts = [currentUser];

      if (this.transaction === 'i purchased them') {
        this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, []);
        this.$store.commit(SET_EVENT_SELECTED_CONTACTS, []);
      } else {
        this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, contacts);
        this.$store.commit(SET_EVENT_SELECTED_CONTACTS, contacts);
      }
    },
    showTransactionModal(transaction) {
      this.transaction = transaction;
      this.$store.commit(SET_CLONE_OPERATION_INFO, null);
      this.$store.commit(SET_SPLIT_PURCHASE_INFO, {});
      this.$store.commit(SET_OPERATION, transaction);
      this.$store.dispatch(SET_OPERATION_IN_ONE_CLICK, true);
      this.setTransactionParticipants();
      this.$emit('modalOpened');
      this.$bvModal.show('add-transaction');
    },
  },
  computed: {
    user() {
      return this.$store.getters.getProfile;
    },
    userContactBook() {
      return this.$store.getters.userContactBook;
    },
  },
  mounted() {
    this.modalToOpen = this.modal;
  },
};
</script>

<style lang="scss" scoped>
.title-add {
  display: flex;
  height: 36px;
  justify-content: space-between;
  align-items: center;
}

.title-add__title {
  font-size: 24px;
  margin: auto 0;
  font-weight: bold;
}

::v-deep {
  .dropdown-toggle {
    padding: 0;
    border-radius: 50%;
    border: none!important;
    background: none!important;
    box-shadow: none!important;
  }
  .dropdown-item span::first-letter {
    text-transform: uppercase;
  }
}
</style>
